import React from 'react'
import {connect} from 'react-redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import qs from 'qs';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getGestorOperacoes,
    getOperadorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import buscarPedidosItinerario from '../../actions/pedido/buscarPedidosItinerario';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import embarcarPassageiro from '../../actions/reserva/embarcarPassageiro';
import desembarcarPassageiro from '../../actions/reserva/desembarcarPassageiro';
import ReciboPassagem from '../pedido/ReciboPassagem';
import ModalImpressaoReciboPassageiro from '../pedido/ModalImpressaoReciboPassageiro';
import ReactToPrint from 'react-to-print';
import TooltipAjuda from '../comum/TooltipAjuda';

export class PainelRecibosItinerario extends React.Component {
    constructor(props) {
        super(props);
        this.componentRef = React.createRef();
        this.state = {
            referencias: null,
            reservaSelecionada: '',
            retorno: '/painel-itinerarios',
        }
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, {ignoreQueryPrefix: true});
        if (parametros.tipo === 'embarque') {
            this.setState({retorno: '/painel-embarque-passageiros'})
        }
        if (parametros.itinerario) {
            this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario);
            this.props.buscarPedidosItinerario(this.props.empresaSelecionada.id, parametros.itinerario).then(
                this.gerarReferencias()
            );

        } else {
            this.props.history.push('/painel-itinerarios');
        }
    }

    gerarReferencias() {
        const ref = new Map();
        ref.set('AGENCIA', {
            id: 'agencia',
            nome: 'Vias de controle das agências',
            nomeParaImpressao: 'Via de controle da agẽncia',
            referencia: React.createRef()
        });
        ref.set('COMPRADOR$', {
            id: 'comprador',
            nome: 'Vias dos compradores',
            nomeParaImpressao: 'Via do comprador',
            referencia: React.createRef()
        });
        ref.set('TODOS_PASSAGEIROS', {
            id: 'todos',
            nome: 'Todas as vias dos passageiros',
            nomeParaImpressao: 'Todas as vias dos passageiros',
            referencia: React.createRef()
        });
        this.setState({referencias: ref})
    }

    exibirBotaoImprimir() {
        return (
            <React.Fragment>
                <ReactToPrint
                    trigger={() => <a style={{cursor: 'pointer'}} className="btn btn-laranja">
                        <i className="material-icons mr-1" style={{
                            fontSize: '18px',
                            verticalAlign: 'middle'
                        }}>
                            &#xe8ad;
                        </i>
                        Imprimir
                    </a>}
                    content={() => this.componentRef.current}
                />
            </React.Fragment>)
    }

    getTitulo() {
        return (
            <div className="col-12 titulo-principal">
                <h1 id="titulo-page" className="tit-desenv" onClick={() => window.close()} style={{cursor: 'pointer'}}>
                    <i className="material-icons custom-icons">&#xe5c4;</i>
                    Recibos de itinerário
                    <TooltipAjuda id='ajudaTitulo' />
                    <p className="linha"> </p>
                </h1>
            </div>
        )
    }

    exibirRecibos() {
        if (!this.props.pedidos.length) {
            return ''
        }
        return this.props.pedidos.map(pedido => <ReciboPassagem key={pedido.id}
                                                                modoImpressaoSimplificado={true}
                                                                pedido={pedido}
                                                                isItinerario={true}/>)
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getMotoristaEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="row internas col-md-12 d-flex justify-content-center mb-2">                    
                    {this.getTitulo()}
                    <div className='col-md-12 d-flex justify-content-center mb-2'>
                        {this.exibirBotaoImprimir()}
                    </div>
                    <div className="printer-ticket" ref={this.componentRef}>
                        {this.exibirRecibos()}
                    </div>
                </div>
                <ModalImpressaoReciboPassageiro referencias={this.state.referencias}/>
            </Autorizacao>
        )
    }
}

export function mapStateToProps(state) {
    return {
        pedidos: state.pedidos.pedidosItinerario,
        itinerarioSelecionado: state.itinerarioSelecionado,
        empresaSelecionada: state.empresaSelecionada
    }
}


export default connect(mapStateToProps, {
    buscarItinerario,
    buscarPedidosItinerario,
    embarcarPassageiro,
    desembarcarPassageiro
})(PainelRecibosItinerario);
